export default "__VITE_ASSET__Bjh7X_DV__"